import { defineMessages } from 'react-intl'

export default defineMessages({
  history: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.history',
    defaultMessage: 'History',
  },
  you: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.you',
    defaultMessage: 'You',
  },
  alert: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.alert',
    defaultMessage: 'Message can not be empty.',
  },
  send: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.send',
    defaultMessage: 'Send',
  },
  typeMessage: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.typeMessage',
    defaultMessage: 'Type message...',
  },
})
